export default __webpack_public_path__ + "static/media/cp_geo_se.2c17c00b.svg";